import React from 'react';
import { useNavigate } from 'react-router-dom';
import botonEspecialidad from '../assets/images/boton_especialidad.png';

const EspecialidadCard = ({ title, image, altText }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    let section = '';
    switch(title) {
      case 'Implantología Bucomaxilofacial':
        section = 'implantologia';
        break;
      case 'Rehabilitación Oral':
        section = 'rehabilitacion';
        break;
      case 'Diseño de Sonrisa':
        section = 'diseno-sonrisa';
        break;
      default:
        section = '';
    }
    navigate(`/servicios#${section}`);
  };

  return (
    <div className="especialidades-item" style={{ position: 'relative', height: '150px', overflow: 'hidden', borderRadius: '10px' }}>
      <img src={image} alt={altText} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
      <button 
        onClick={handleClick}
        style={{
          position: 'absolute',
          top: '10px',
          left: '50%',
          transform: 'translateX(-50%)',
          backgroundColor: '#4CAF50',
          color: 'white',
          border: 'none',
          padding: '4px 10px',
          borderRadius: '5px',
          cursor: 'pointer',
          maxWidth: '90%',
          fontSize: '0.8em'
        }}
      >
        {title}
      </button>

      <div className="flecha" style={{
        position: 'absolute',
        bottom: '8px',
        right: '8px',
        cursor: 'pointer'
      }}>
        <button onClick={handleClick} style={{
          border: 'none',
          background: 'none',
          padding: 0,
          cursor: 'pointer'
        }}>
          <img 
            src={botonEspecialidad} 
            alt="Ver más" 
            style={{
              width: '35px',
              height: '35px'
            }}
          />
        </button>
      </div>
    </div>
  );
};

export default EspecialidadCard; 